//class
import PadCreator from '../PadCreator';
// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
// consts
import { TYPE } from 'app/config/prescription_content';
// form
// classes
import { PadPrescriptionType } from './PadPrescriptionType';

/**
 * represents an instance of PadPrescriptionMedicament
 * @class PadPrescriptionMedicament
 * @extends PadCreator
 */
export default class PadPrescriptionMedicament extends PadCreator {
  prepare(padPrescriptionMedicaments = []) {
    const preparedMedicaments = padPrescriptionMedicaments.map(padPrescriptionMedicament => {
      const code = codeGeneretor();
      const type = TYPE.SUSTEINED; // mantido
      const padPrescriptionSuggestSched =
        padPrescriptionMedicament.padPrescriptionSuggestionScheduling;

      padPrescriptionMedicament.suggestScheduling = _.isEmpty(padPrescriptionSuggestSched) ? 0 : 1;

      return {
        code,
        type,
        padPrescriptionMedicament
      };
    });

    this._loadedData = _.cloneDeep(preparedMedicaments);
    this._screenData = _.cloneDeep(preparedMedicaments);

    return this;
  }

  /**
   * insert a new medicament.
   * @param {object} medicament - new medicament.
   * @returns {object} the state
   */
  add(medicament) {
    const padPrescription = _.cloneDeep(medicament);

    padPrescription.code = codeGeneretor();

    this._screenData.push(padPrescription);

    return this;
  }

  /**
   * update a medicament.
   * @param {string} code - medicament`s code to be edited.
   * @param {object} medicament - medicament to be edited.
   * @returns {object} return the state
   */
  edit(code, medicament = {}) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(medicament);

    // find index by code
    const indexScreenToEdit = [...this._screenData].findIndex(item => item.code === code);

    Object.entries(padPrescription).forEach(([key, content]) => {
      this._screenData[indexScreenToEdit][key] = content;
    });

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnEdit(padPrescription);

    this._screenData[indexScreenToEdit].type = type;

    return this;
  }

  /**
   * remove a element.
   * @param {string} code - element`s code to remove.
   * @returns {object} return the state
   */
  remove(code) {
    const newScreen = [...this._screenData].filter(currentElement => currentElement.code !== code);

    this._screenData = newScreen;

    return this;
  }
}
